import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

interface Response {
  active_accounts_count?: number | null;
  canceled_accounts_count?: number | null;
}
const QUERY_KEY = 'PARTICIPANT_ACTIVITY_REPORT_CARD';
const useParticipantActivityReportCardQuery = () => {
  const { data, isLoading } = useQuery(
    [QUERY_KEY],
    // TODO: the type is missing
    () => api.get<Response>(API_URL.REPORTS_PARTICIPANT_ACCOUNT_ACTIVITY_REPORT_BRIEF),
    {
      cacheTime: 0,
    }
  );
  const formattedData = useMemo(() => {
    const response = data?.data;
    const canceledAccounts = response?.canceled_accounts_count;
    const activatedAccounts = response?.active_accounts_count;
    return {
      activeCount: activatedAccounts || activatedAccounts === 0 ? `${activatedAccounts || 0}` : null,
      canceledCount: canceledAccounts || canceledAccounts === 0 ? `${canceledAccounts || 0}` : null,
    };
  }, [data?.data]);
  return {
    isLoading,
    data: formattedData,
  };
};

export default useParticipantActivityReportCardQuery;
